// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-tests-section h2,
.turing-ui-v2-tests-section h3 {
  color: #212121;
}
.turing-ui-v2-tests-section h2 {
  font-weight: 500;
}
.turing-ui-v2-tests-section h3 {
  font-size: 14px;
}
.turing-ui-v2-tests-section h2 + small,
.turing-ui-v2-tests-section h3 + small {
  color: #888888;
  display: block;
  margin-bottom: 20px;
}

.turing-ui-v2-tests-section h2 {
  display: flex;
}

.turing-ui-v2-tests-section {
  margin-top: 50px;
  border-top: 2px solid rgb(240, 240, 240);
  padding-top: 50px;
}

.turing-ui-v2-tests-section:first-child {
  border-top: none !important;
  margin-top: 0;
}

.hide-border {
  border: none !important;
  margin-top: 0 !important;
}

.turing-ui-v2-work-exp-not-complete {
  opacity: 0.4 !important;
}

.turing-ui-v2-disable-mcq-card {
  pointer-events: none !important;
  cursor: not-allowed !important;
  opacity: 0.5
}

.turing-ui-v2-lock-work-exp-info {
  margin-left: 12px;
  text-align: left !important;
  font-size: 12px !important;
  line-height: 24px !important;
  letter-spacing: 0 !important;
  color: #888888 !important;
  opacity: 1 !important;
}

.test-welcome-call-section {
  margin-top: 24px;
}

.turing-ui-v2-lock-work-exp-wrapper {
  margin-left: 12px !important;
}

.turing-ui-v2-tests-sub-section-title {
  display: flex;
  align-items: center;
  margin: 20px 10px;
}

.turing-ui-v2-tests-sub-section-title > .green {
  color: rgb(119, 192, 9);
}

.turing-ui-v2-tests-sub-section-title > .gray {
  color: rgb(133, 133, 133);
}

.turing-ui-v2-tests-sub-section-title > * + * {
  margin: 0 0 0 10px;
  flex: 1;
}

.turing-ui-v2-mcq-tests-list {
  display: flex;
  flex-wrap: wrap;
  /* align-items: flex-start; */
  justify-content: flex-start;
  position: relative;
}

.turing-ui-v2-mcq-tests-item {
  background: #fff;
  padding: 10px;
  /* box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45); */
  border: 1px solid #eeeeee;
  border-radius: 8px;
  /* cursor: pointer; */
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.turing-ui-v2-mcq-tests-item:hover {
  box-shadow: 1px 1px 7px 0 rgba(204, 204, 204, 0.53);
  /* -moz-transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -o-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05); */
}

.turing-ui-v2-mcq-tests-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  border-radius: 8px;
  padding: 30px 10px 20px;
  text-align: center;
  min-height: 248px;
  max-height: 248px;
  position: relative;
}
.turing-ui-v2-mcq-tests-item-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.turing-ui-v2-mcq-tests-item-icon img.mcq {
  width: 50px;
  height: 50px;
  z-index: 2;
}
.turing-ui-v2-mcq-tests-item-icon img.certified-bg {
  position: absolute;
  z-index: 1;
  top: 28px;
}

.turing-ui-v2-item-certified img.mcq {
  background-color: #fff;
  border-radius: 50%;
  margin-top: -4px;
}

.turing-ui-v2-item-certified {
  margin-bottom: 45px !important;
}

.turing-ui-v2-mcq-tests-item-content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 5px;
  flex: 1;
  min-height: 42px;
}
.turing-ui-v2-mcq-tests-item-title {
  font-weight: 500;
  min-height: 22px;
}
.turing-ui-v2-mcq-tests-item-time-estimate {
  color: #444;
  border-radius: 8px;
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  width: 80px;
  background-color: #f8f8f8;
}
.turing-ui-v2-mcq-tests-item-time-clock {
  margin-right: 5px;
  height: 15px;
  width: 15px;
}
.turing-ui-v2-mcq-tests-item-time-clock path {
  fill: #444;
}

.turing-ui-v2-mcq-tests-item-tag {
  margin: 5px;
  color: #bbb;
  border-radius: 5px;
  font-size: 11px;
  padding: 4px;
  max-width: 145px;
  text-align: center;
}

.turing-ui-v2-test-top-section {
  display: flex;
}
.turing-ui-v2-test-top-section > .turing-ui-v2-test-top-section-left {
  flex: 1;
}

.turing-ui-v2-top-skills-in-demand {
  display: flex;
  flex-direction: column;
  margin: 0 0 10px 10px;
  background: #fff;
  padding: 20px;
  box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45);
  border-radius: 5px;
}

.turing-ui-v2-top-skills-in-demand > b {
  margin-bottom: 3px;
  display: block;
}

.turing-ui-v2-top-skills-in-demand > small {
  color: #808080;
  font-size: 10px;
  margin-bottom: 10px;
  display: block;
}

.turing-ui-v2-top-skills-in-demand > ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

.turing-ui-v2-top-skills-in-demand li {
  margin: 2px;
  display: flex;
}

.turing-ui-v2-top-skills-in-demand li span {
  color: #808080;
  min-width: 20px;
  text-align: center;
}
.turing-ui-v2-top-skills-in-demand li span + span {
  margin-left: 10px;
  flex: 1;
  color: black;
  text-align: left;
}

.turing-ui-v2-test-top-section-form {
  display: flex;
  align-items: center;
}
.turing-ui-v2-test-top-section-form b {
  margin-right: 10px;
}
.turing-ui-v2-test-top-section-form b + * {
  width: 200px;
}

.turing-ui-v2-test-top-section-left h1 {
  font-weight: 500;
}

.turing-ui-v2-test-top-section-left p {
  margin: 30px 0;
  color: #888888;
  line-height: 24px;
}

@media screen and (max-width: 900px) {
  .practiceMcq {
    flex-direction: column;
  }
  .turing-tests-workexp {
    flex-direction: column;
  }
}

@media screen and (max-width: 508px) {
  .turing-ui-v2-test-top-section {
    flex-direction: column;
  }
  .turing-ui-v2-top-skills-in-demand {
    margin: 15px;
  }
}

.turing-ui-v2-mcq-tests-item-time-left-wrap {
  display: flex;
  gap: 5px;
  width: fit-content;
  margin: auto;
}

.turing-ui-v2-mcq-tests-item-time-paused {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d8ebfd;
  color: #063e75;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
}

.turing-ui-v2-mcq-tests-item-time-paused svg {
  margin-right: 5px;
  height: 11px;
  width: 12px;
}

.turing-ui-v2-mcq-tests-item-time-paused svg path {
  fill: #063e75;
}

.turing-ui-v2-mcq-tests-item-time-left {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  color: #444;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
}

.turing-ui-v2-mcq-tests-item-time-left svg {
  margin-right: 5px;
  height: 14px;
  width: 15px;
}

.turing-ui-v2-mcq-tests-item-time-left svg path {
  fill: #444;
}

.turing-ui-v2-mcq-tests-item-time .didntpass-wrap {
  display: flex;
  gap: 5px;
}

.turing-ui-v2-mcq-tests-item-time .didntpass {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffe5e6;
  color: #750507;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
}

.turing-ui-v2-mcq-tests-item-time .didntpass svg {
  margin-right: 5px;
  height: 12px;
  width: 12px;
}

.turing-ui-v2-mcq-tests-item-time .didntpass svg path {
  fill: #750507;
}

.turing-ui-v2-mcq-tests-item-time .retake {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  color: #444;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 12px;
}

.turing-ui-v2-mcq-tests-item-time .retake svg {
  margin-right: 5px;
  height: 14px;
  width: 14px;
}

.turing-ui-v2-mcq-tests-item-time .retake svg path {
  fill: #444;
}

.turing-ui-v2-mcq-tests-item-time .completed {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e0f5e6;
  color: #1f5c2e;
  border-radius: 8px;
  margin: auto;
  width: fit-content;
  padding: 2px 8px;
  font-size: 12px;
}

.turing-ui-v2-mcq-tests-item-time .completed svg {
  margin-right: 5px;
  height: 14px;
  width: 14px;
}

.turing-ui-v2-mcq-tests-item-time .completed svg path {
  fill: #1f5c2e;
}

.turing-ui-v2-mcq-tests-list-left-nav,
.turing-ui-v2-mcq-tests-list-right-nav {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  top: 108px;
  background-color: #fff;
  box-shadow: 2px 2px 3px 0 #cecece;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.turing-ui-v2-mcq-tests-list-left-nav {
  position: absolute;
  left: -70px;
}

.turing-ui-v2-mcq-tests-list-right-nav {
  position: absolute;
  right: -70px;
}

.turing-ui-v2-tests-section-header {
  display: flex;
  justify-content: space-between;
}

.turing-ui-v2-start-mcq-modal-actions {
  display: flex;
  align-items: center;
  margin-top: 40px;
  justify-content: flex-end;
}

.no-margin-top {
  margin-top: 0px;
}

.turing-ui-v2-start-mcq-modal-actions > * + * {
  margin-left: 20px;
}

.turing-ui-v2-start-mcq-modal-container .ant-card-body {
  padding: 40px;
}

.turing-ui-v2-start-mcq-modal-container .mcq-icon {
  max-width: 64px;
  margin-bottom: 16px;
}

.turing-ui-v2-mcq-modal .ant-modal-content {
  border-radius: 10px;
  overflow: hidden;
}

.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar {
  width: 10px;
}

.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,.15);
  background-clip: content-box;
  -webkit-border-radius: 8px;
  border: 2px solid transparent;
}

.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-thumb:hover {
  -webkit-border-radius: 8px;
  border: 2px solid transparent;
}

.turing-ui-v2-recommended {
  text-transform: uppercase;
  color: #56a8f7;
  margin: 20px 0;
}

.turing-ui-v2-mcq-tests-item-recommended {
  text-transform: uppercase;
  color: #56a8f7;
}

.ant-tooltip-inner,
.ant-tooltip-arrow:before {
  background-color: #666666 !important;
}

.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item {
  color: #2e6edf !important;
  border-radius: 6px !important;
  border: 1px solid #2e6edf !important;
  font-weight: 600;
  width: 100%;
}

.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item {
  color: #2e6edf !important;
  border-radius: 6px !important;
  padding: 4px 0 2px !important;
  border: 1px solid #2e6edf !important;
  font-weight: 600;
  width: 100%;
}

.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item:hover,
.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item:active {
  background-color: #fff !important;
}

.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item:hover,
.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item:active {
  background-color: #fff !important;
}

.turing-ui-v2-reattempt {
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  height: 36px;
  cursor: text;
  color: #888888 !important;
}

.turing-ui-v2-reattempt.pointer {
    cursor: pointer;
}

.turing-ui-v2-completed {
  font-weight: 500;
  font-size: 14px;
  padding: 6px 0;
  cursor: text;
  color: #888888 !important;
}

.turing-ui-v2-reattempt {
  color: #2e6edf !important;
}

.tooltip-message {
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  opacity: 1;
}

.turing-ui-v2-tests-section-header small {
  font-size: 14px;
}

.turing-ui-v2-not-enough-skills {
  display: flex;
  flex-direction: column;
  min-height: 200px;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  background: #fff;
  padding: 40px;
  box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45);
  border-radius: 5px;
}

.turing-ui-v2-action-small-text {
  font-size: 10px;
  color: gray;
}

.turing-ui-v2-tests-section-content .ant-tabs-nav .ant-tabs-tab:last-child {
  color: #1890ff !important;
  font-weight: bold !important;
}

.turing-ui-v2-tests-section-content .ant-tabs-tab-active {
  color: black !important;
  font-weight: bold !important;
}

.turing-ui-v2-tests-section-filters {
  display: grid;
  grid-template-areas: "test-filters-skills test-filters-search";
  grid-template-columns: 2fr 1fr;
}

.turing-ui-v2-tests-section-filters-skills {
  grid-area: test-filters-skills;
  padding-right: 0.5rem;
}

.turing-ui-v2-tests-section-filters-search {
  grid-area: test-filters-search;
  padding-left: 0.5rem;
}

.importantIcon {
  width: 16px;
  height: 16px;
  /* background: transparent url(\${ importantIcon }) 0% 0% no-repeat padding-box; */
  opacity: 1;
}

.star {
  background: transparent;
  color: #666666;
  margin-left: 0.51rem;
  font-size: 10px;
  padding: 0;
  border-radius: 10px;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.filter-skill {
  display: flex !important;
  align-items: center;
  border-radius: 6px !important;
  border: 1px solid #aaaaaa !important;
  background: #fff !important;
}

.filter-skill.ant-tag-checkable-checked {
  background: #dce6fa !important;
  color: #10316a !important;
  border: none !important;
}

.filter-skill .skill-item {
  display: flex;
}

.filter-skill .skill-item svg {
  margin-right: 5px;
  fill: #10316a;
  display: none;
}

.filter-skill .skill-item svg path {
  fill: #10316a;
}

.filter-skill.ant-tag-checkable-checked .skill-item svg {
  display: inline;
}

.turing-page-title {
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 150%;
  color: #212121;
}

.turing-tests-heading {
  font-size: 28px;
  font-weight: 500;
}

.turing-tests-recommendation-wrapper {
  display: flex;
  gap: 16px;
}

.turing-tests-recommendation {
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  padding: 24px 32px;
  gap: 24px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.turing-tests-practice-mcq {
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.turing-tests-practice-test {
  font-weight: 500;
}

.turing-tests-steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 40px;
}

.turing-ui-v2-mcq-tests-item-time {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.turing-tests-steps .additional-tests-disabled {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.turing-tests-steps .additional-tests-disabled .title {
  color: #aaa;
  margin-bottom: 0;
}

.turing-tests-workexp {
  display: flex;
  gap: 20px;
}

.turing-tests-workexp .turing-tests-testimonial {
  min-height: 220px !important;
}

.DevFlowStep {
  padding: 32px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;
}

.DevFlowStep-disabled {
  opacity: 0.5;
}

.DevFlowStep-disabled-overdiv {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.DevFlowStep-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  max-width: 100%;
}

.DevFlowStep .ant-tabs-tab-active {
  color: #2e6edf !important;
  font-weight: 600;
}

.DevFlowStep .ant-tabs-tab .tab-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.DevFlowStep .ant-tabs-tab .tab-title-count {
  margin-left: 6px;
  font-size: 12px;
  padding: 0 8px;
  border-radius: 8px;
  background-color: #ddd;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.DevFlowStep .ant-tabs-nav .ant-tabs-tab:hover .tab-title-count {
  background-color: #dce6fa;
}

.DevFlowStep .edit-button {
  display: flex;
  gap: 6px;
  align-items: center;
  color: #2e6edf;
  border-radius: 8px;
  padding: 4px 10px;
  font-weight: 600;
  transition: all 0.3s;
}

.DevFlowStep .edit-button:hover {
  color: #2e6edf;
  background-color: #dce6fa;
}

.DevFlowStep .edit-button svg path {
  fill: #2e6edf;
}

.DevFlowStep .ant-tabs-tab-active .tab-title-count {
  background-color: #dce6fa;
}

.DevFlowStep-step {
  background: linear-gradient(90deg, #6c7bd4 0%, #56a8f7 100%);
  border-radius: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #ffffff;
  padding: 4px 16px;
  align-self: flex-start;
}

.DevFlowStep-title-container {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.DevFlowStep-title {
  font-weight: 500;
  font-style: normal;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #212121;
}

.DevFlowStep-status {
  display: flex;
  gap: 5px;
  padding: 0px 5px;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  border-radius: 6px;
  min-height: 24px;
}

.DevFlowStep-roundUncheck {
  display: inline-block;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  border: 2px solid #444444;
}

.DevFlowStep-unlock {
  display: flex;
  align-items: center;
  background-color: #d8ebfd;
  border-radius: 8px;
  padding: 6px 12px;
  color: #063e75;
}

.DevFlowStep-unlock svg {
  margin-right: 8px;
  width: 12px;
  height: 15px;
}

.DevFlowStep-unlock svg path {
  fill: #063e75;
}

.DevFlowStep-completed {
  background-color: #e0f5e6;
  color: #1f5c2e;
}

.DevFlowStepbox-completed {
  color: #1f5c2e;
}

.DevFlowStep-notcompleted {
  background-color: #f8f8f8;
  color: #444444;
}

.DevFlowStep-description {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #212121;
}

.DevFlowStepSuccessMessage {
  background: linear-gradient(90deg, #1c48bf 0%, #b93dfd 100%);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
  transform: scaleY(0);
  padding: 16px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #ffffff;
  display: flex;
  align-items: center;
  height: auto;
  gap: 16px;
}

.DevFlowStepSuccessMessage > div {
  flex: 1;
}

.DevFlowStepSuccessMessage > .DevFlowStepSuccessMessage-icon {
  font-size: 48px;
  font-weight: 500;
}

.DevFlowStepSuccessMessage > .DevFlowStepSuccessMessage-close {
  cursor: pointer;
}

.DevFlowStepSuccessMessage p {
  margin: 0;
}

.DevFlowStepSuccessMessage-visible {
  transform: scaleY(1);
}

.practiceMcq {
  display: flex;
}

.practiceMcq .practiceContent {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* padding: 20px; */
}

.practiceMcq .practiceContent .practiceTitle {
  font-size: 18px;
}

.TakeRelevantTestsSection {
  position: relative;
}

.DevFlowStepBox {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 180px;
  height: 248px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 16px;
}

.DevFlowStepBox-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #212121;
}

.DevFlowStepBox-time {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #aaaaaa;
}

.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/tests/Tests.css"],"names":[],"mappings":"AAAA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B;AACF;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uDAAuD;EACvD,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mDAAmD;EACnD;;;;2BAIyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EACjC,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".turing-ui-v2-tests-section h2,\n.turing-ui-v2-tests-section h3 {\n  color: #212121;\n}\n.turing-ui-v2-tests-section h2 {\n  font-weight: 500;\n}\n.turing-ui-v2-tests-section h3 {\n  font-size: 14px;\n}\n.turing-ui-v2-tests-section h2 + small,\n.turing-ui-v2-tests-section h3 + small {\n  color: #888888;\n  display: block;\n  margin-bottom: 20px;\n}\n\n.turing-ui-v2-tests-section h2 {\n  display: flex;\n}\n\n.turing-ui-v2-tests-section {\n  margin-top: 50px;\n  border-top: 2px solid rgb(240, 240, 240);\n  padding-top: 50px;\n}\n\n.turing-ui-v2-tests-section:first-child {\n  border-top: none !important;\n  margin-top: 0;\n}\n\n.hide-border {\n  border: none !important;\n  margin-top: 0 !important;\n}\n\n.turing-ui-v2-work-exp-not-complete {\n  opacity: 0.4 !important;\n}\n\n.turing-ui-v2-disable-mcq-card {\n  pointer-events: none !important;\n  cursor: not-allowed !important;\n  opacity: 0.5\n}\n\n.turing-ui-v2-lock-work-exp-info {\n  margin-left: 12px;\n  text-align: left !important;\n  font-size: 12px !important;\n  line-height: 24px !important;\n  letter-spacing: 0 !important;\n  color: #888888 !important;\n  opacity: 1 !important;\n}\n\n.test-welcome-call-section {\n  margin-top: 24px;\n}\n\n.turing-ui-v2-lock-work-exp-wrapper {\n  margin-left: 12px !important;\n}\n\n.turing-ui-v2-tests-sub-section-title {\n  display: flex;\n  align-items: center;\n  margin: 20px 10px;\n}\n\n.turing-ui-v2-tests-sub-section-title > .green {\n  color: rgb(119, 192, 9);\n}\n\n.turing-ui-v2-tests-sub-section-title > .gray {\n  color: rgb(133, 133, 133);\n}\n\n.turing-ui-v2-tests-sub-section-title > * + * {\n  margin: 0 0 0 10px;\n  flex: 1;\n}\n\n.turing-ui-v2-mcq-tests-list {\n  display: flex;\n  flex-wrap: wrap;\n  /* align-items: flex-start; */\n  justify-content: flex-start;\n  position: relative;\n}\n\n.turing-ui-v2-mcq-tests-item {\n  background: #fff;\n  padding: 10px;\n  /* box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45); */\n  border: 1px solid #eeeeee;\n  border-radius: 8px;\n  /* cursor: pointer; */\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n}\n\n.turing-ui-v2-mcq-tests-item:hover {\n  box-shadow: 1px 1px 7px 0 rgba(204, 204, 204, 0.53);\n  /* -moz-transform: scale(1.05);\n  -webkit-transform: scale(1.05);\n  -o-transform: scale(1.05);\n  -ms-transform: scale(1.05);\n  transform: scale(1.05); */\n}\n\n.turing-ui-v2-mcq-tests-item {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  min-width: 200px;\n  max-width: 200px;\n  border-radius: 8px;\n  padding: 30px 10px 20px;\n  text-align: center;\n  min-height: 248px;\n  max-height: 248px;\n  position: relative;\n}\n.turing-ui-v2-mcq-tests-item-icon {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n.turing-ui-v2-mcq-tests-item-icon img.mcq {\n  width: 50px;\n  height: 50px;\n  z-index: 2;\n}\n.turing-ui-v2-mcq-tests-item-icon img.certified-bg {\n  position: absolute;\n  z-index: 1;\n  top: 28px;\n}\n\n.turing-ui-v2-item-certified img.mcq {\n  background-color: #fff;\n  border-radius: 50%;\n  margin-top: -4px;\n}\n\n.turing-ui-v2-item-certified {\n  margin-bottom: 45px !important;\n}\n\n.turing-ui-v2-mcq-tests-item-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  margin: 5px;\n  flex: 1;\n  min-height: 42px;\n}\n.turing-ui-v2-mcq-tests-item-title {\n  font-weight: 500;\n  min-height: 22px;\n}\n.turing-ui-v2-mcq-tests-item-time-estimate {\n  color: #444;\n  border-radius: 8px;\n  display: flex;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  background-color: #f8f8f8;\n}\n.turing-ui-v2-mcq-tests-item-time-clock {\n  margin-right: 5px;\n  height: 15px;\n  width: 15px;\n}\n.turing-ui-v2-mcq-tests-item-time-clock path {\n  fill: #444;\n}\n\n.turing-ui-v2-mcq-tests-item-tag {\n  margin: 5px;\n  color: #bbb;\n  border-radius: 5px;\n  font-size: 11px;\n  padding: 4px;\n  max-width: 145px;\n  text-align: center;\n}\n\n.turing-ui-v2-test-top-section {\n  display: flex;\n}\n.turing-ui-v2-test-top-section > .turing-ui-v2-test-top-section-left {\n  flex: 1;\n}\n\n.turing-ui-v2-top-skills-in-demand {\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 10px 10px;\n  background: #fff;\n  padding: 20px;\n  box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45);\n  border-radius: 5px;\n}\n\n.turing-ui-v2-top-skills-in-demand > b {\n  margin-bottom: 3px;\n  display: block;\n}\n\n.turing-ui-v2-top-skills-in-demand > small {\n  color: #808080;\n  font-size: 10px;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.turing-ui-v2-top-skills-in-demand > ol {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.turing-ui-v2-top-skills-in-demand li {\n  margin: 2px;\n  display: flex;\n}\n\n.turing-ui-v2-top-skills-in-demand li span {\n  color: #808080;\n  min-width: 20px;\n  text-align: center;\n}\n.turing-ui-v2-top-skills-in-demand li span + span {\n  margin-left: 10px;\n  flex: 1;\n  color: black;\n  text-align: left;\n}\n\n.turing-ui-v2-test-top-section-form {\n  display: flex;\n  align-items: center;\n}\n.turing-ui-v2-test-top-section-form b {\n  margin-right: 10px;\n}\n.turing-ui-v2-test-top-section-form b + * {\n  width: 200px;\n}\n\n.turing-ui-v2-test-top-section-left h1 {\n  font-weight: 500;\n}\n\n.turing-ui-v2-test-top-section-left p {\n  margin: 30px 0;\n  color: #888888;\n  line-height: 24px;\n}\n\n@media screen and (max-width: 900px) {\n  .practiceMcq {\n    flex-direction: column;\n  }\n  .turing-tests-workexp {\n    flex-direction: column;\n  }\n}\n\n@media screen and (max-width: 508px) {\n  .turing-ui-v2-test-top-section {\n    flex-direction: column;\n  }\n  .turing-ui-v2-top-skills-in-demand {\n    margin: 15px;\n  }\n}\n\n.turing-ui-v2-mcq-tests-item-time-left-wrap {\n  display: flex;\n  gap: 5px;\n  width: fit-content;\n  margin: auto;\n}\n\n.turing-ui-v2-mcq-tests-item-time-paused {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #d8ebfd;\n  color: #063e75;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time-paused svg {\n  margin-right: 5px;\n  height: 11px;\n  width: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time-paused svg path {\n  fill: #063e75;\n}\n\n.turing-ui-v2-mcq-tests-item-time-left {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f8f8;\n  color: #444;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time-left svg {\n  margin-right: 5px;\n  height: 14px;\n  width: 15px;\n}\n\n.turing-ui-v2-mcq-tests-item-time-left svg path {\n  fill: #444;\n}\n\n.turing-ui-v2-mcq-tests-item-time .didntpass-wrap {\n  display: flex;\n  gap: 5px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .didntpass {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffe5e6;\n  color: #750507;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .didntpass svg {\n  margin-right: 5px;\n  height: 12px;\n  width: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .didntpass svg path {\n  fill: #750507;\n}\n\n.turing-ui-v2-mcq-tests-item-time .retake {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f8f8;\n  color: #444;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .retake svg {\n  margin-right: 5px;\n  height: 14px;\n  width: 14px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .retake svg path {\n  fill: #444;\n}\n\n.turing-ui-v2-mcq-tests-item-time .completed {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #e0f5e6;\n  color: #1f5c2e;\n  border-radius: 8px;\n  margin: auto;\n  width: fit-content;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .completed svg {\n  margin-right: 5px;\n  height: 14px;\n  width: 14px;\n}\n\n.turing-ui-v2-mcq-tests-item-time .completed svg path {\n  fill: #1f5c2e;\n}\n\n.turing-ui-v2-mcq-tests-list-left-nav,\n.turing-ui-v2-mcq-tests-list-right-nav {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  top: 108px;\n  background-color: #fff;\n  box-shadow: 2px 2px 3px 0 #cecece;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.turing-ui-v2-mcq-tests-list-left-nav {\n  position: absolute;\n  left: -70px;\n}\n\n.turing-ui-v2-mcq-tests-list-right-nav {\n  position: absolute;\n  right: -70px;\n}\n\n.turing-ui-v2-tests-section-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.turing-ui-v2-start-mcq-modal-actions {\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n  justify-content: flex-end;\n}\n\n.no-margin-top {\n  margin-top: 0px;\n}\n\n.turing-ui-v2-start-mcq-modal-actions > * + * {\n  margin-left: 20px;\n}\n\n.turing-ui-v2-start-mcq-modal-container .ant-card-body {\n  padding: 40px;\n}\n\n.turing-ui-v2-start-mcq-modal-container .mcq-icon {\n  max-width: 64px;\n  margin-bottom: 16px;\n}\n\n.turing-ui-v2-mcq-modal .ant-modal-content {\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-thumb {\n  background-color: rgba(0,0,0,.15);\n  background-clip: content-box;\n  -webkit-border-radius: 8px;\n  border: 2px solid transparent;\n}\n\n.turing-ui-v2-mcq-modal > .ant-modal-content > .ant-modal-body::-webkit-scrollbar-thumb:hover {\n  -webkit-border-radius: 8px;\n  border: 2px solid transparent;\n}\n\n.turing-ui-v2-recommended {\n  text-transform: uppercase;\n  color: #56a8f7;\n  margin: 20px 0;\n}\n\n.turing-ui-v2-mcq-tests-item-recommended {\n  text-transform: uppercase;\n  color: #56a8f7;\n}\n\n.ant-tooltip-inner,\n.ant-tooltip-arrow:before {\n  background-color: #666666 !important;\n}\n\n.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item {\n  color: #2e6edf !important;\n  border-radius: 6px !important;\n  border: 1px solid #2e6edf !important;\n  font-weight: 600;\n  width: 100%;\n}\n\n.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item {\n  color: #2e6edf !important;\n  border-radius: 6px !important;\n  padding: 4px 0 2px !important;\n  border: 1px solid #2e6edf !important;\n  font-weight: 600;\n  width: 100%;\n}\n\n.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item:hover,\n.turing-ui-v2-mcq-tests-item .turing-ui-v2-action-item:active {\n  background-color: #fff !important;\n}\n\n.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item:hover,\n.turing-ui-v2-mcq-tests-item-time .turing-ui-v2-action-item:active {\n  background-color: #fff !important;\n}\n\n.turing-ui-v2-reattempt {\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 14px;\n  height: 36px;\n  cursor: text;\n  color: #888888 !important;\n}\n\n.turing-ui-v2-reattempt.pointer {\n    cursor: pointer;\n}\n\n.turing-ui-v2-completed {\n  font-weight: 500;\n  font-size: 14px;\n  padding: 6px 0;\n  cursor: text;\n  color: #888888 !important;\n}\n\n.turing-ui-v2-reattempt {\n  color: #2e6edf !important;\n}\n\n.tooltip-message {\n  text-align: center;\n  font-size: 12px;\n  color: #ffffff;\n  opacity: 1;\n}\n\n.turing-ui-v2-tests-section-header small {\n  font-size: 14px;\n}\n\n.turing-ui-v2-not-enough-skills {\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n  align-items: center;\n  justify-content: center;\n  margin: 10px 0;\n  background: #fff;\n  padding: 40px;\n  box-shadow: 1px 1px 1px rgba(204, 204, 204, 0.45);\n  border-radius: 5px;\n}\n\n.turing-ui-v2-action-small-text {\n  font-size: 10px;\n  color: gray;\n}\n\n.turing-ui-v2-tests-section-content .ant-tabs-nav .ant-tabs-tab:last-child {\n  color: #1890ff !important;\n  font-weight: bold !important;\n}\n\n.turing-ui-v2-tests-section-content .ant-tabs-tab-active {\n  color: black !important;\n  font-weight: bold !important;\n}\n\n.turing-ui-v2-tests-section-filters {\n  display: grid;\n  grid-template-areas: \"test-filters-skills test-filters-search\";\n  grid-template-columns: 2fr 1fr;\n}\n\n.turing-ui-v2-tests-section-filters-skills {\n  grid-area: test-filters-skills;\n  padding-right: 0.5rem;\n}\n\n.turing-ui-v2-tests-section-filters-search {\n  grid-area: test-filters-search;\n  padding-left: 0.5rem;\n}\n\n.importantIcon {\n  width: 16px;\n  height: 16px;\n  /* background: transparent url(${ importantIcon }) 0% 0% no-repeat padding-box; */\n  opacity: 1;\n}\n\n.star {\n  background: transparent;\n  color: #666666;\n  margin-left: 0.51rem;\n  font-size: 10px;\n  padding: 0;\n  border-radius: 10px;\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  -webkit-justify-content: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  align-items: center;\n}\n\n.filter-skill {\n  display: flex !important;\n  align-items: center;\n  border-radius: 6px !important;\n  border: 1px solid #aaaaaa !important;\n  background: #fff !important;\n}\n\n.filter-skill.ant-tag-checkable-checked {\n  background: #dce6fa !important;\n  color: #10316a !important;\n  border: none !important;\n}\n\n.filter-skill .skill-item {\n  display: flex;\n}\n\n.filter-skill .skill-item svg {\n  margin-right: 5px;\n  fill: #10316a;\n  display: none;\n}\n\n.filter-skill .skill-item svg path {\n  fill: #10316a;\n}\n\n.filter-skill.ant-tag-checkable-checked .skill-item svg {\n  display: inline;\n}\n\n.turing-page-title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 150%;\n  color: #212121;\n}\n\n.turing-tests-heading {\n  font-size: 28px;\n  font-weight: 500;\n}\n\n.turing-tests-recommendation-wrapper {\n  display: flex;\n  gap: 16px;\n}\n\n.turing-tests-recommendation {\n  border-radius: 8px;\n  background: #FFFFFF;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n  padding: 24px 32px;\n  gap: 24px;\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.turing-tests-practice-mcq {\n  background: #FFFFFF;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n.turing-tests-practice-test {\n  font-weight: 500;\n}\n\n.turing-tests-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 40px;\n}\n\n.turing-ui-v2-mcq-tests-item-time {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n\n.turing-tests-steps .additional-tests-disabled {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.turing-tests-steps .additional-tests-disabled .title {\n  color: #aaa;\n  margin-bottom: 0;\n}\n\n.turing-tests-workexp {\n  display: flex;\n  gap: 20px;\n}\n\n.turing-tests-workexp .turing-tests-testimonial {\n  min-height: 220px !important;\n}\n\n.DevFlowStep {\n  padding: 32px;\n  background: #ffffff;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  position: relative;\n}\n\n.DevFlowStep-disabled {\n  opacity: 0.5;\n}\n\n.DevFlowStep-disabled-overdiv {\n  position: absolute;\n  z-index: 100;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.DevFlowStep-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  max-width: 100%;\n}\n\n.DevFlowStep .ant-tabs-tab-active {\n  color: #2e6edf !important;\n  font-weight: 600;\n}\n\n.DevFlowStep .ant-tabs-tab .tab-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n}\n\n.DevFlowStep .ant-tabs-tab .tab-title-count {\n  margin-left: 6px;\n  font-size: 12px;\n  padding: 0 8px;\n  border-radius: 8px;\n  background-color: #ddd;\n  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.DevFlowStep .ant-tabs-nav .ant-tabs-tab:hover .tab-title-count {\n  background-color: #dce6fa;\n}\n\n.DevFlowStep .edit-button {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  color: #2e6edf;\n  border-radius: 8px;\n  padding: 4px 10px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.DevFlowStep .edit-button:hover {\n  color: #2e6edf;\n  background-color: #dce6fa;\n}\n\n.DevFlowStep .edit-button svg path {\n  fill: #2e6edf;\n}\n\n.DevFlowStep .ant-tabs-tab-active .tab-title-count {\n  background-color: #dce6fa;\n}\n\n.DevFlowStep-step {\n  background: linear-gradient(90deg, #6c7bd4 0%, #56a8f7 100%);\n  border-radius: 20px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #ffffff;\n  padding: 4px 16px;\n  align-self: flex-start;\n}\n\n.DevFlowStep-title-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.DevFlowStep-title {\n  font-weight: 500;\n  font-style: normal;\n  font-size: 20px;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n  color: #212121;\n}\n\n.DevFlowStep-status {\n  display: flex;\n  gap: 5px;\n  padding: 0px 5px;\n  align-items: center;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  border-radius: 6px;\n  min-height: 24px;\n}\n\n.DevFlowStep-roundUncheck {\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  border: 2px solid #444444;\n}\n\n.DevFlowStep-unlock {\n  display: flex;\n  align-items: center;\n  background-color: #d8ebfd;\n  border-radius: 8px;\n  padding: 6px 12px;\n  color: #063e75;\n}\n\n.DevFlowStep-unlock svg {\n  margin-right: 8px;\n  width: 12px;\n  height: 15px;\n}\n\n.DevFlowStep-unlock svg path {\n  fill: #063e75;\n}\n\n.DevFlowStep-completed {\n  background-color: #e0f5e6;\n  color: #1f5c2e;\n}\n\n.DevFlowStepbox-completed {\n  color: #1f5c2e;\n}\n\n.DevFlowStep-notcompleted {\n  background-color: #f8f8f8;\n  color: #444444;\n}\n\n.DevFlowStep-description {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.DevFlowStepSuccessMessage {\n  background: linear-gradient(90deg, #1c48bf 0%, #b93dfd 100%);\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n  transform: scaleY(0);\n  padding: 16px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  height: auto;\n  gap: 16px;\n}\n\n.DevFlowStepSuccessMessage > div {\n  flex: 1;\n}\n\n.DevFlowStepSuccessMessage > .DevFlowStepSuccessMessage-icon {\n  font-size: 48px;\n  font-weight: 500;\n}\n\n.DevFlowStepSuccessMessage > .DevFlowStepSuccessMessage-close {\n  cursor: pointer;\n}\n\n.DevFlowStepSuccessMessage p {\n  margin: 0;\n}\n\n.DevFlowStepSuccessMessage-visible {\n  transform: scaleY(1);\n}\n\n.practiceMcq {\n  display: flex;\n}\n\n.practiceMcq .practiceContent {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  /* padding: 20px; */\n}\n\n.practiceMcq .practiceContent .practiceTitle {\n  font-size: 18px;\n}\n\n.TakeRelevantTestsSection {\n  position: relative;\n}\n\n.DevFlowStepBox {\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 4px;\n  width: 180px;\n  height: 248px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  padding: 16px;\n}\n\n.DevFlowStepBox-title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 21px;\n  text-align: center;\n  color: #212121;\n}\n\n.DevFlowStepBox-time {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: center;\n  color: #aaaaaa;\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
